import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export const trackAmplitudeNavigationClick = (sectionName: string, sectionNumber: number, selectedTab: string) => {
    trackAmplitudeEvent("select_section", {
        section_name: sectionName,
        section_number: sectionNumber,
        selected_tab: selectedTab
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export const trackAmplitudeNavigationClick = (sectionName: string, sectionNumber: number, selectedTab: string) => {
    trackAmplitudeEvent("select_section", {
        section_name: sectionName,
        section_number: sectionNumber,
        selected_tab: selectedTab
    });
};
